module.exports = __webpack_public_path__ + "img/pattern1.60dd055.svg";